export default "__VITE_ASSET__Byab0kQq__"